import { useContext } from 'react';
import { StoreContext } from '@roc/feature-app-core';
import LoanClosingConditionStore from '../stores/loanClosingConditionStore';

export const useLoanClosingConditionStore = () =>
  useContext<{
    loanClosingConditionStore: LoanClosingConditionStore;
  }>(StoreContext);